<template>
    <div>
        <b-button v-if="isOrgAdmin" variant="info" @click="changeEdit()">Редактировать</b-button>
        <div>
            <div id="viewer">
            
            </div>
            <div class="map">

            </div>
        </div>
        <Dialog v-if="is_edit">
            <h4 slot="header">Редактирование контактов</h4>
            <div slot="body" id="editor" style="max-height:50vh; height:50vh; overflow:auto">
            </div>
            <div slot="footer">
                <b-button variant="info" @click="edit_content()">Сохранить</b-button>
                <b-button variant="danger" @click="is_edit = false">Отменить</b-button>
            </div>
        </Dialog>
    </div>    
</template>

<script>
import Dialog from '@app/views/custom-components/modals/edit-modal.vue';
import { organizationApi } from '@app/services';

export default {
     components: {
        Dialog
    },
    data() {
        return {
            quill: null,
            edit_quill: null,
            is_edit: false
        };
    },
    computed: {
        isOrgAdmin() {
            const role = this.$store.state.clinic.roles.filter(obj => obj === 'orgadmin')[0];
            return role ? true : false;
        },
    },
     mounted() {
        this.quill = new Quill('#viewer', {
            theme: 'bubble',
            readOnly:true
        });
        if(this.$store.state.clinic.organization.form.front.contacts) {
            this.quill.setContents(this.$store.state.clinic.organization.form.front.contacts);
        } else {
            this.quill.setText('Не заполнено');
        }
    },
    methods: {
        changeEdit() {
            this.is_edit = true;
                setTimeout(() => { 
                const toolbarOptions = [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote'],

                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image'], ['link']

                ];
            this.edit_quill = new Quill('#editor', {
                    theme: 'snow',
                    readOnly:false,
                    modules: {
                        toolbar: toolbarOptions
                    }
                }); this.edit_quill.setContents(this.quill.getContents());
                }, 100);
        },
        edit_content() {
            this.quill.setContents(this.edit_quill.getContents());
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (front.contacts) {
                backup = Object.assign({}, front.contacts);
                front.contacts = Object.assign({}, this.edit_quill.getContents());
            } else {
                backup = {};
                front.contacts = Object.assign({}, this.edit_quill.getContents());
            }
            organizationApi.update({front: front}).then(res => {
                this.is_edit = false;
            }).catch(error => {
                console.log(error);
                front.contacts = Object.assign({}, backup);
            });
        }
    }
};
</script>

<style lang="scss" scoped>

</style>